import React, { useContext } from 'react';
import { useForm } from 'react-final-form';

import Buttons from '../../Modal/Buttons/Buttons';
import Breadcrumbs from '../Breadcrumbs/Breadcrumbs';
import CreateTournamentContext from '../CreateTournamentContext/CreateTournamentContext';
import { ModalPagesNames } from '../utils/common';

import { TXTCLI_Next, TXTMOB_Create } from './Container.messages.json';
import styles from './Container.scss';

const Container: React.FC = ({ children }) => {
  const {
    state: { activePage, loading }
  } = useContext(CreateTournamentContext);
  const isFirstPage = activePage === 0;
  const isLastPage = activePage + 1 === ModalPagesNames.length;
  const { valid } = useForm().getState();

  return (
    <>
      <Breadcrumbs />
      <div className={styles.form}>{children}</div>
      <div className={styles.buttonsWrapper}>
        <Buttons
          disabled={loading || !valid}
          translation={isLastPage ? TXTMOB_Create : TXTCLI_Next}
          hideBackButton={isFirstPage}
          isSubmit={isLastPage}
        />
      </div>
    </>
  );
};

export default Container;
